import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import back from "../../Assets/Image/admin/back.png";
import add from "../../Assets/Image/admin/add.png";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import { deleteQuestion, getQuestion } from "../../Services/ApiServices";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { IMG_URL } from "../../Services/Api";
import { CircleX, Eye, Trash2 } from "lucide-react";
import Dialog from "../../Base-Component/Dialog/Dialog";

function Question() {
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [selectStatus, setSelectStatus] = useState("1");
  const [totalPage, setTotalPage] = useState("");
  const [quesId, setQuesId] = useState("");
  const [isIndex, setIsIndex] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const { id } = useParams();

  const [formValue, setFormValue] = useState({});

  const [userData, setUserData] = useState([]);

  const handleSubCategoryList = () => {
    setLoader(true);
    let obj = {
      quiz_id: id,
      page: pageNo,
    };
    getQuestion(obj)
      .then((res) => {
        const data = res.data.data;
        setUserData(data);
        setTotalPage(res.data.totalPages);
        setLoader(false);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleSubCategoryList();
  }, [pageNo, selectStatus]);

  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const handleAddQuestion = () => {
    navigate("/question/add-questions/" + id);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let obj = {
      question_id: quesId,
    };
    deleteQuestion(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...userData];
        data.splice(isIndex, 1);
        setUserData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        setIsLoading(false);
      });
  };

  const handleDeletes = (id, index) => {
    setIsDelete(true);
    setIsIndex(index);
    setQuesId(id);
    setIsLoading(false);
  };

  const handleView = (data) => {
    setFormValue(data);
    setModalOpens(true);
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-between mb-7">
        <div className="flex items-center cursor-pointer mb-4">
          <img
            src={back}
            onClick={() => {
              navigate("/quiz");
            }}
            className="w-4"
            alt=""
          />
          <p
            onClick={() => {
              navigate("/quiz");
            }}
            className="text-base font-medium ms-3 p-0"
          >
            Go back
          </p>
        </div>
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          <div>
            <button
              onClick={handleAddQuestion}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Question
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                {userData.map((item, index) => {
                  const mediaFile = item.quiz_Question_image;
                  const fileExtension = mediaFile
                    ? mediaFile.split(".").pop().toLowerCase()
                    : "";
                  const isImage = ["jpg", "jpeg", "png"].includes(
                    fileExtension
                  );
                  const isVideo = ["mp4", "mov"].includes(fileExtension);
                  return (
                    <div
                      key={index}
                      className="xl:col-span-4 md:col-span-6 col-span-12 bg-white rounded-lg"
                    >
                      <div className="p-5">
                        <div>
                          <h4 className="font-medium">
                            QUESTION ID : {item.id}
                          </h4>
                        </div>
                        <div className="mt-3">
                          <div className="flex justify-center">
                            {isImage && (
                              <img
                                src={mediaFile ? IMG_URL + mediaFile : ""}
                                className="h-52 rounded-lg"
                                alt="Question"
                              />
                            )}
                            {isVideo && (
                              <video
                                src={mediaFile ? IMG_URL + mediaFile : ""}
                                controls
                                className="h-52 rounded-lg"
                              ></video>
                            )}
                          </div>
                          <ul className="mt-3 ms-4 list-disc">
                            <li className="text-lg font-medium truncate 2xl:w-[350px] xl:w-[250px] w-[250px]">
                              {item.question_text || ""}
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="border-t flex justify-end py-3 px-5 font-medium text-sm">
                        <p
                          onClick={() => handleView(item)}
                          className="flex items-center font-medium text-[#3b82f6] mr-2"
                        >
                          <Eye color="#3b82f6" size={17} className="mr-1" />{" "}
                          View
                        </p>
                        <p
                          className="flex items-center font-medium text-[#e43232] cursor-pointer"
                          onClick={(e) => handleDeletes(item.id, index)}
                        >
                          <Trash2 color="#e43232" size={17} className="mr-1" />{" "}
                          Delete
                        </p>
                      </div>
                    </div>
                  );
                })}
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Quetion?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Question?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:w-auto w-[330px] md:max-h-[700px] h-[500px] overflow-auto fontNew">
              <div className="flex justify-between border-b p-5">
                <h4 className="text-lg font-medium">Question Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setModalOpens(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="p-5">
                <ul className="ms-4 list-disc">
                  <li className="text-lg font-medium">
                    {formValue.question_text || ""}
                  </li>
                </ul>
                <ul className="list-decimal ms-4 mt-3">
                  {formValue?.Answers?.map((item, index) => {
                    return (
                      <li className="my-2" key={index}>
                        {item.answer_text || "-"}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default Question;
